module.exports = __webpack_public_path__ + "static/media/051-root_canal.1569f56c.svg";